import { render } from "./AppColorPicker.vue?vue&type=template&id=c7a7a86a&scoped=true"
import script from "./AppColorPicker.vue?vue&type=script&lang=js"
export * from "./AppColorPicker.vue?vue&type=script&lang=js"

import "./AppColorPicker.vue?vue&type=style&index=0&id=c7a7a86a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a7a86a"]])

export default __exports__